import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function VCMessage({ 
  accent = "#115e32",
  pageTitle = "VC Message | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]">
      {/* Hero Section with SVG */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE]">
        {/* SVG Decorative Background */}
        <div className="absolute inset-0 flex justify-center items-center opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="650"
            height="650"
            viewBox="0 0 650 650"
            fill="none"
            className="animate-spin-slow"
          >
            <circle
              cx="325"
              cy="325"
              r="280"
              stroke="#d4af37"
              strokeWidth="3"
              strokeDasharray="12 12"
            />
            <circle
              cx="325"
              cy="325"
              r="180"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="8 8"
            />
          </svg>
        </div>

        <div className="relative container mx-auto px-6 py-20 text-center">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-800"
          >
            Message from the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#2563eb]">
              Vice Chancellor
            </span>
          </motion.h1>
        </div>
      </section>

      {/* VC Message Section */}
      <section className="relative container mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        {/* VC Picture */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center"
        >
          <img
            src="/img/Gazi-Reza-pro-vc.jpg" // replace with actual VC image path
            alt="Vice Chancellor"
            className="w-80 h-96 object-cover rounded-2xl shadow-lg border-4 border-[#014864]"
          />
        </motion.div>

        {/* VC Message */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6 text-gray-700"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-[#014864]">
            Professor Md Zahid Hossain Sharif, PhD
          </h2>
          <p className="italic text-sm text-gray-500">
            The Hon’ble Vice-Chancellor <br />
            Bir Muktijoddha
          </p>
          <p className="leading-relaxed">
            I am delighted to express my enthusiasm for the University of
            Creative Technology Chattogram (UCTC), which commenced its
            commendable journey in 2017 and has received accreditation from the
            University Grants Commission, Bangladesh.
          </p>
          <p className="leading-relaxed">
            UCTC comprises three faculties: the School of Sciences and
            Engineering, offering programs such as B.Sc in Mechanical
            Engineering, B.Sc in Civil Engineering, and B.Sc in Computer Science
            and Engineering; the School of Arts and Social Sciences, featuring
            English Language and Literature; and the School of Business,
            offering BBA (Honors) and MBA programs.
          </p>
          <p className="leading-relaxed">
            Our faculty includes globally qualified individuals with Ph.D., M.S.,
            and MBA degrees from prestigious institutions worldwide, including
            alumni from renowned institutions like BUET, KUET, CUET, DU, and CU.
          </p>
          <p className="leading-relaxed">
            The university recently introduced three new programs: BSc in
            Electrical and Electronic Engineering, BA in Islamic Studies, and
            Master in Islamic Studies, following approval from the University
            Grants Commission.
          </p>
          <p className="leading-relaxed">
            UCTC places a strong emphasis on research, with faculty actively
            contributing to internationally acclaimed peer-reviewed journals.
            The institution serves as a vibrant hub of knowledge, innovation,
            and academic excellence.
          </p>
        </motion.div>
      </section>
    </div>
  );
}
